import type { PinPlaceV1 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'
import { localDate } from '../lib/time.ts'

/** M16-C (docs/M16.md rule 2): the projection of pin.place@1, a field FACT. The placement shows on this device at once, pending, on the club's own
 *  day (the typed day, else the command's instant in the site's zone, as the server derives it), with the sector tapped and the offsets typed, until the
 *  server's row replaces it. The id is the device's own (newId), so a retry duplicates nothing; the correction columns are the office's to write.
 *  pin.correct@1, pin_exclusion.set@1 / close@1 and flag_settings.set@1 are intents: no projection (`none` in the registry). */
export const pinPlace: Projector = async (cmd, db) => {
  const p = cmd.payload as PinPlaceV1
  const tz = ((await db.site.get(cmd.site_id)) as { timezone?: string } | undefined)?.timezone ?? 'Europe/Paris'
  const row: OverlayRow = {
    key: `ops.pin_placement:${p.placement_id}`, table: 'ops.pin_placement', id: p.placement_id, command_id: cmd.command_id, op: 'insert',
    row: {
      id: p.placement_id, org_id: cmd.org_id, site_id: cmd.site_id, area_id: p.area_id, placed_on: p.placed_on ?? localDate(cmd.occurred_at, tz), placed_at: cmd.occurred_at,
      sector_code: p.sector_code.trim(), offset_front_m: p.offset_front_m ?? null, offset_side_m: p.offset_side_m ?? null, note: p.note?.trim() || null,
      job_id: p.job_id ?? null, corrects_placement_id: null, superseded_by_id: null, actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
